module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row progetti"
  }, _vm._l((_vm.filtrati), function(item, index) {
    return _c('div', {
      staticClass: "progetto col col-s12 m6",
      on: {
        "remove": function($event) {
          _vm.onRemove(index)
        }
      }
    }, [(item.link == '1') ? _c('router-link', {
      attrs: {
        "to": '/inside/progetto/p' + item.id
      }
    }, [_c('img', {
      attrs: {
        "src": '/site/images/p/' + item.id + '.jpg'
      }
    })]) : _vm._e(), _vm._v(" "), (item.link != '1') ? _c('img', {
      attrs: {
        "src": '/site/images/p/' + item.id + '.jpg'
      }
    }) : _vm._e(), _vm._v(" "), (item.stato != '') ? _c('el-tooltip', {
      staticStyle: {
        "float": "right"
      },
      attrs: {
        "content": item.stato,
        "placement": "top"
      }
    }, [_c('i', {
      staticClass: "material-icons"
    }, [_vm._v("menu")])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "titolo"
    }, [_vm._v(_vm._s(item.titolo))])], 1)
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b1fcce8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tipologia.vue
// module id = 351
// module chunks = 0